<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter1">
<p class="centerImage"><img alt="images" id="pg_16_1" src="images/pg_16_1.jpg"/></p>
<p class="caption">This was the reality of Mussolini’s armoured forces. The two-man Fiat-Ansaldo turretless Carro Veloce (‘Fast Tank’ or tankette) CV.33 appeared in 1933; it was armed with machine-guns, weighed in at 3.5 tons and had a top speed of 28mph and was really only sufficient for police duties. Two years later it was followed by the slightly improved CV.35 and with the introduction of standard designations (type, weight, year) they became the L3/33 and L3/35 respectively, assigned to infantry support and reconnaissance roles. While the former was armed with a 6.5mm machine-gun and protected by just 12mm of armour, the latter had bolted rather than riveted armour and was equipped with twin 8mm machine-guns. In 1940 the tiny L3 formed the bulk of Mussolini’s tank forces. It equipped three Italian armoured divisions, the tank battalions of the motorised divisions and the tank squadrons of the <em class="italic">Celere</em> or fast divisions. In stark contrast, there were just two battalions with the M11/39. The L3’s combat track record in Ethiopia and Spain was not very good. (<em class="italic">Author’s Collection</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_05_Chapter1.vue?d40399fa